import React from "react";
import { Navigate } from "react-router-dom";
import { useBarbeiro } from "../context/BarbeiroContext";
import Loading from "./Loading"; // Certifique-se de ter este componente

export default function ProtectedRoute({ children, allowedRoles }) {
  const { barbeiro, loadingBarbeiro } = useBarbeiro();

  // 1. Se estiver carregando, NÃO redireciona ainda. Mostra spinner.
  if (loadingBarbeiro) {
    return <Loading />;
  }

  // 2. Se terminou de carregar e não tem usuário, vai pro login
  if (!barbeiro) {
    return <Navigate to="/login" replace />;
  }

  // 3. Se tem usuário, mas o cargo não é permitido, vai pra Home
  // (Isso evita que um barbeiro comum tente acessar o financeiro, por exemplo)
  if (allowedRoles && !allowedRoles.includes(barbeiro.cargo)) {
    return <Navigate to="/" replace />;
  }

  // 4. Tudo certo, renderiza a página
  return children;
}